import { app } from "@microsoft/teams-js";

export function isMobileClient(teamsContext: app.Context): boolean {
  switch (teamsContext.app.host.clientType) {
    case "ios":
    case "android":
      return true;
  }

  return false;
}

export function getCookieValue(name: string) {
  const cookies = document.cookie.split(";");
  const foundCookie = cookies.find(cookie => cookie.includes(name));
  if (!foundCookie) {
    return null;
  }
  const idx = foundCookie.indexOf("=");
  const value = foundCookie.substring(idx);
  return value;
}
